import React, { useState } from "react";
import { CarouselItemBS } from "./CarouselItemBS";
import "./CarouselBS.css";

export const CarouselBS = ({ items, title }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const updateIndex = (newIndex) => {
    if (newIndex < 0) {
      newIndex = items.length - 1;
    } else if (newIndex >= items.length) {
      newIndex = 0; // Wrap to the first item
    }
    setActiveIndex(newIndex);
  };

  return (
    <div className="carousel">
      <div className="title">
        <h3>{title}</h3>
      </div>

      <div
        className="inner"
        style={{ transform: `translate(-${activeIndex * 100}%)` }}
      >
        {items.map((item) => {
          return <CarouselItemBS item={item} width={"100%"} />;
        })}
      </div>
      <div className="carousel-buttonsbs">
        <button
          className="button-arrowhpbs"
          onClick={() => {
            updateIndex(activeIndex - 1);
          }}
        >
          &lt;
        </button>
        <div className="indicatorsbs">
          {items.map((item, index) => {
            return (
              <button
                className="indicator-buttonsbs"
                onClick={() => {
                  updateIndex(index);
                }}
              >
                <span
                  className={`material-symbols-outlined ${
                    index === activeIndex
                      ? "indicator-symbol-activeHPbs"
                      : "indicator-symbolbs"
                  }`}
                >
                  ●
                </span>
              </button>
            );
          })}
        </div>
        <button
          className="button-arrowhpbs"
          onClick={() => {
            updateIndex(activeIndex + 1);
          }}
        >
          &gt;
        </button>
      </div>
    </div>
  );
};

export default CarouselBS;
